import { Box, Button, ButtonProps, Center, Fade, Flex, Heading } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '@/environment';

import { MasterClassListRowType, MasterClassListView } from './MasterClassListView';

type Props = {
  title?: string;
  masterClassList: MasterClassListRowType[];
};

export function MasterClassListClient({ masterClassList, title }: Props) {
  const { t } = useTranslation();

  const handleJoin = useCallback((masterClassId: string) => {
    window.location.href = `${config.MASTERCLASS_URL}/masterclass/${masterClassId}/cases`;
  }, []);

  return (
    <Flex w="full">
      <Box p="20px" bg="livelinx.grey100" h="100%" w="full">
        {masterClassList.length == 0 && (
          <Fade in={true} delay={1}>
            <Box h="full">
              <Center h="100px">
                <Heading size="sm" color="grey">
                  {t('home.noMasterClass')}
                </Heading>
              </Center>
            </Box>
          </Fade>
        )}

        {masterClassList.length > 0 && (
          <Fade in={true}>
            <MasterClassListView
              masterClassList={masterClassList}
              title={title}
              // showId
              showCases
              actions={[
                {
                  render: (item) => {
                    const currentButtonProps: ButtonProps = {
                      onClick: () => {
                        handleJoin(item.id);
                      },
                      children: t('masterClassList.row.join'),
                    };
                    return (
                      <Flex direction="column" gap={2} width="150px">
                        <Button variant="primary" size="md" w="100%" {...currentButtonProps} />
                      </Flex>
                    );
                  },
                },
              ]}
            />
          </Fade>
        )}
      </Box>
    </Flex>
  );
}
